<template>
    <div class="DownloadContentButtons">
        <v-btn icon v-if="showDownloadContentButton" @click="download">
            <v-icon>{{ mdiDownload }}</v-icon>
        </v-btn>
        <v-btn icon v-if="showPrintContentButton" @click="print">
            <v-icon>{{ mdiPrinter }}</v-icon>
        </v-btn>
    </div>
</template>

<script>
import {mdiDownload, mdiPrinter} from '@mdi/js';
import {brandName} from "../../../../../config/app";
import {fetchPagePartContentForDownload, fetchPagePartContentForPrint} from "../../../../api";
import apiData from "../../../../mixins/apiData";
import Toaster from "../../../../mixins/toaster";

export default {
    name: "DownloadContentButtons",

    mixins: [apiData, Toaster],

    props: ['showDownloadContentButton', 'showPrintContentButton', 'pagePartId'],

    data: function () {
        return {
            mdiDownload: mdiDownload,
            mdiPrinter: mdiPrinter,
        };
    },

    methods: {
        download() {
            fetchPagePartContentForDownload(this.createApiData({
                pagePartId: this.pagePartId,
            }))
                .then(data => {
                    let element = document.createElement('a');
                    element.style.display = 'none';

                    if (data.content) {
                        let fileName = this.$route.params.slug || brandName;

                        element.setAttribute('href', 'data:text/html;charset=utf-8,' + encodeURIComponent(data.content));
                        element.setAttribute('download', `${fileName}.html`);
                    } else if (data.link) {
                        element.setAttribute('href', data.link);
                        element.setAttribute('download', data.link.split('/').pop());
                    }

                    document.body.appendChild(element);

                    element.click();

                    document.body.removeChild(element);
                })
                .catch(() => this.makeErrorToast(this.$t('front.api.service_unavailable')));
        },

        print() {
            fetchPagePartContentForPrint(this.createApiData({
                pagePartId: this.pagePartId,
            }))
                .then(data => {
                    let generator = window.open(",'name,");

                    generator.document.write(data.content);

                    generator.document.close();

                    generator.print();

                    generator.close();
                })
                .catch(() => this.makeErrorToast(this.$t('front.api.service_unavailable')));
        },
    },
}
</script>

<style scoped lang="sass">
@import "sass/components/pages/parts/contents/DownloadContentButtons"
</style>